import React from 'react';
import { OfferCommonRejectionDrawer } from '@applicant-flow/components';
import { useMutation } from '@common/hooks';
import { PERFORM_OFFER_ACTION_MUTATION } from '@applicant-flow/graphql';
import { createMessage } from 'works/legacy/lib/message-helper';
import { OfferRejectionReasons } from '@common/graphql';

export const OfferRejectionDrawer = ({
  open,
  onClose,
  offerId,
}: {
  open: boolean;
  onClose: () => void;
  offerId?: string;
}) => {
  const [performAction, { loading }] = useMutation(
    PERFORM_OFFER_ACTION_MUTATION,
    {
      onCompleted() {
        createMessage('success', 'Offer successfully rejected!');
        onClose();
      },
      onError: () => {
        createMessage(
          'error',
          'Failed to update Offer state. Please try again or contact your hiring partner.'
        );
      },
    }
  );

  const onRejectClick = (
    reason: OfferRejectionReasons | null,
    rejectionDetails: string
  ) => {
    if (!offerId) return;

    performAction({
      variables: {
        offerId: offerId,
        input: {
          action: 'reject',
          reason: reason,
          rejectionDetails: rejectionDetails,
        },
      },
    });
  };

  return (
    <OfferCommonRejectionDrawer
      title="Reject Offer"
      open={open}
      onDrawerClose={onClose}
      onRejectClick={onRejectClick}
      buttonLoading={loading}
    />
  );
};
